import React from 'react';

const PillTab = ({ label, active, onClick }) => {
    const className = `PillTabs-item ${active ? 'is-active' : ''}`;
    return (
        <div className={className} onClick={onClick}>{label}</div>
    )
}

export default PillTab;


// WEBPACK FOOTER //
// ./components/PillTab.js